import React from 'react';
import { Row } from '../../../Layouts';
import { Text } from '../../../UI/Text';
import { CalendarEvent } from './style';
import { getFormattedDateFromMomentObject, parseToMoment } from '../../../../Utils/timeConvertorHelper';
import { timeFormats } from '../../../../Constants/timeFormats';

export const EventComponent = ({ name, start, end, onClick }) => (
    <CalendarEvent onClick={onClick}>
        <Row>
            <Text opacity={0.75} fontSize={10} weight={100}>
                {getFormattedDateFromMomentObject(parseToMoment(start), timeFormats.INCOMPLETE_TIME)} -{' '}
                {getFormattedDateFromMomentObject(parseToMoment(end), timeFormats.INCOMPLETE_TIME)}
            </Text>
        </Row>
        <Text fontSize={11} marginTop={'5px'} opacity={0.75} weight={400}>
            {name}
        </Text>
    </CalendarEvent>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/Event.js